module.exports = __webpack_public_path__ + "static/media/cancel.ef490191.svg";